import { render, staticRenderFns } from "./FormUrbanPlagas.vue?vue&type=template&id=d74cf9fc&scoped=true"
import script from "./FormUrbanPlagas.vue?vue&type=script&lang=js"
export * from "./FormUrbanPlagas.vue?vue&type=script&lang=js"
import style0 from "./FormUrbanPlagas.vue?vue&type=style&index=0&id=d74cf9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74cf9fc",
  null
  
)

export default component.exports